module.exports = __webpack_public_path__ + "static/media/Simbolo_Stroj.4041f166.png";